import React from "react";
import "./About.css";
import aboutImage from "../assets/banner.jpg";

function About() {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-image">
          <img src={aboutImage} alt="Sobre a Empresa" />
        </div>
        <div className="about-text">
          <h2>Sobre Nós</h2>
          <p>
          A Leal Transporte Executivo é a escolha certa para quem busca qualidade, segurança e conforto em cada trajeto. Conte com nossa pontualidade e profissionalismo para transformar suas viagens em uma experiência única. 
      
          </p>
          <p>
            Contamos com frota moderna e motoristas treinados para atender diferentes
            demandas, desde trajetos corporativos até eventos e turismo.
          </p>
          <p>
          Fale conosco e eleve o padrão das suas viagens!
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
